import { render } from "./AppCursor.vue?vue&type=template&id=2df94add"
import script from "./AppCursor.vue?vue&type=script&lang=js"
export * from "./AppCursor.vue?vue&type=script&lang=js"

import "./AppCursor.vue?vue&type=style&index=0&id=2df94add&lang=scss"

import exportComponent from "/Users/lucas/Web/_loco/theadccawards/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__